import React, {useState} from 'react';
import PropTypes from "prop-types";
import html2pdf from "html2pdf.js";
import html2canvas from 'html2canvas';
import axios from "../../../../utils/apiClient";
import SpinnerLoading from "../../../common/components/spinner";
import {getErrorCode, TRACK_EVENTS, trackPendoEvent} from "../../../../utils/pendoTrack";

const componentName = "previsitChartDownloader";
const PVCPdfDownloader = ({rootElementId, rootHeaderId , downloadFileName, patientIds, footerLogo}) => {
    const [buttonText, setButtonText] = useState('Download PDF');
    const [isDisabled, setIsDisabled] = useState(false);

    const downloadPdfDocument = () => {
        setIsDisabled(true);
        setButtonText('Downloading PDF');

        const input = document.getElementById(rootElementId);
        const newDate = new Date();
        const date = newDate.getDate();
        const month = newDate.getMonth() + 1;
        const year = newDate.getFullYear();
        const config = {
            margin:       [30, 10, 30, 10],
            filename:     `${downloadFileName}-${month}-${date}-${year}.pdf`,
            image:        { type: 'jpeg', quality: 0.75 },
            html2canvas:  { scale: 2, logging: false, dpi: 192, letterRendering: false },
            jsPDF:        { unit: 'mm', format: 'a4', orientation: 'portrait' }
        };
        const validPatientIds = Array.isArray(patientIds) ? patientIds.filter(Boolean) : [];
        if (validPatientIds.length > 0) {
            axios.post(
                process.env.REACT_APP_REST_API_BASE_URL +
                `/v1/patient-card/log-auditor`,
                validPatientIds,
                {
                    headers: {},
                }
            ).catch((error) => {
                trackPendoEvent(TRACK_EVENTS.CHART_PREP_PDF_DOWNLOAD, {
                    source_module: "PVCPdfDownloader.downloadPdfDocument",
                    patient_count: validPatientIds.length,
                    success: false,
                    error_code: getErrorCode(error, "chart_prep_pdf_audit_log_failed")
                });
            });
        }
        html2canvas(document.getElementById(rootHeaderId)).then(canvas => { 
            const pdfHeader = canvas.toDataURL('image/jpeg');
            html2pdf().from(input).set(config).toPdf().get('pdf').then((pdf) => {
                const totalPages = pdf.internal.getNumberOfPages();
                const pdfFooter = "Disclaimer: The information present is reflective of previously reported data, from multiple sources and is not intended to be used in place of medical diagnosis or treatment, which are solely the responsibility of the practitioner. If the data received is incomplete or inaccurate, reported results may require review or revision accordingly. Any risk scores or related financial forecasts are estimates only and actual risk factors and/or quality measures or other results may vary. This information may not be appropriate for, and should not be used for other purposes. The information should not be parsed out or reviewed out of context of the entire report.";
                for (let i = 1; i <= totalPages; i++) {
                    pdf.setPage(i);
                    pdf.setFontSize(8);
                    pdf.addImage(pdfHeader, 'JPEG', 10, 10, pdf.internal.pageSize.getWidth() - 20, 18, null, 'none', 0 );
                    pdf.text(pdfFooter, 10, pdf.internal.pageSize.getHeight() - 25, { maxWidth: 165 });
                    pdf.addImage(footerLogo, 'JPEG', pdf.internal.pageSize.getWidth() - 30, pdf.internal.pageSize.getHeight() - 25, 10, 10, null, 'none', 0);
                    pdf.text('Pg ' + String(i), pdf.internal.pageSize.getWidth() - 10, pdf.internal.pageSize.getHeight() - 20, "right");
                }
            }).save().then(() => {
                trackPendoEvent(TRACK_EVENTS.CHART_PREP_PDF_DOWNLOAD, {
                    source_module: "PVCPdfDownloader.downloadPdfDocument",
                    patient_count: Array.isArray(patientIds) ? patientIds.length : 0,
                    success: true
                });
                setIsDisabled(false);
                setButtonText('Download PDF');
            }).catch((error) => {
                trackPendoEvent(TRACK_EVENTS.CHART_PREP_PDF_DOWNLOAD, {
                    source_module: "PVCPdfDownloader.downloadPdfDocument",
                    patient_count: Array.isArray(patientIds) ? patientIds.length : 0,
                    success: false,
                    error_code: getErrorCode(error, "chart_prep_pdf_download_failed")
                });
                setIsDisabled(false);
                setButtonText('Download PDF');
            });
        }).catch((error) => {
            trackPendoEvent(TRACK_EVENTS.CHART_PREP_PDF_DOWNLOAD, {
                source_module: "PVCPdfDownloader.downloadPdfDocument",
                patient_count: Array.isArray(patientIds) ? patientIds.length : 0,
                success: false,
                error_code: getErrorCode(error, "chart_prep_pdf_render_failed")
            });
            setIsDisabled(false);
            setButtonText('Download PDF');
        });
    }
    return (
        <>
            {isDisabled && <SpinnerLoading />}
            <button id={`${componentName}-downloadChartPrepPDF`} onClick={downloadPdfDocument} className="btn btn-primary" disabled={isDisabled}>{buttonText}</button>
        </>
    );
}

PVCPdfDownloader.propTypes = {
    rootElementId: PropTypes.string.isRequired,
    rootHeaderId: PropTypes.string.isRequired,
    downloadFileName: PropTypes.string.isRequired,
    patientIds: PropTypes.array,
    footerLogo: PropTypes.string
};

export default PVCPdfDownloader;
